import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { Link, useLocation } from 'react-router-dom'; // Import useLocation
import { Collapse } from 'reactstrap';
import { getUserData } from '../../Services/DataServices';

// Import Data
import navdata from "../LayoutMenuData";
// i18n
import { withTranslation } from "react-i18next";

const VerticalLayout = (props) => {
    const [itemMenu, setItemMenu] = useState([]);

    const loginUserRole = getUserData()?.role;
    
    const location = useLocation(); // Use useLocation hook
    useEffect(() => {
        if (loginUserRole === 'user') {
            setItemMenu(navdata.filter(item => item.isCustomer));
        } else if (loginUserRole === 'admin') {
            setItemMenu(navdata); // Admin can access all items
        } else if(loginUserRole === 'superadmin'){
            setItemMenu(navdata.filter(item => item.isSuperAdmin));
        } else if(loginUserRole === 'viewuser'){
            setItemMenu(navdata.filter(item => item.isViewUser));
        }
    }, [loginUserRole]);
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const initMenu = () => {
            const pathName = process.env.PUBLIC_URL + location.pathname; // Use location.pathname
            const ul = document.getElementById("navbar-nav");
            const items = ul.getElementsByTagName("a");
            let itemsArray = [...items]; // converts NodeList to Array
            removeActivation(itemsArray);
            let matchingMenuItem = itemsArray.find((x) => {
                return x.pathname === pathName;
            });
            if (matchingMenuItem) {
                activateParentDropdown(matchingMenuItem);
            }
        };
        if (props.layoutType === "vertical") {
            initMenu();
        }
    }, [location.pathname, props.layoutType]); // Use location.pathname

    function activateParentDropdown(item) {
        item.classList.add("active");
        let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

        if (parentCollapseDiv) {
            // to set aria expand true remaining
            parentCollapseDiv.classList.add("show");
            parentCollapseDiv.parentElement.children[0].classList.add("active");
            parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
            if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
                if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
                    parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
            }
            return false;
        }
        return false;
    }

    const removeActivation = (items) => {
        let actiItems = items.filter((x) => x.classList.contains("active"));

        actiItems.forEach((item) => {
            if (item.classList.contains("menu-link")) {
                if (!item.classList.contains("active")) {
                    item.setAttribute("aria-expanded", false);
                }
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
            }
            if (item.classList.contains("nav-link")) {
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
                item.setAttribute("aria-expanded", false);
            }
            item.classList.remove("active");
        });
    };

    return (
        <React.Fragment>
            {itemMenu.map((item, key) => (
                <React.Fragment key={key}>
                    <li className="nav-item">
                        <Link className="nav-link menu-link" to={item.link ? item.link : "/#"}>
                            <i className={item.icon}></i> <span>{props.t(item.label)}</span>
                        </Link>
                    </li>
                </React.Fragment>
            ))}
        </React.Fragment>
    );
};

VerticalLayout.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(VerticalLayout); // No need for withRouter